import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import { AuthenticationService } from '@era/inroom-sdk';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import {
  LoadRoomConfiguration,
  RoomConfigurationActionsUnion,
  RoomConfigurationActionTypes,
  RoomConfigurationLoaded,
  SetRoomConfiguration,
} from './room-configuration.actions';

@Injectable()
export class RoomConfigurationEffects {
  private readonly actions$ = inject<Actions<RoomConfigurationActionsUnion>>(Actions);
  private readonly api = inject(AuthenticationService);

  resolveRoomConfigurationEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomConfigurationActionTypes.LOAD_ROOM_CONFIGURATION),
      switchMap((action: LoadRoomConfiguration) =>
        this.api.getToken({ hotelCode: action.payload.hotelCode, room: action.payload.unitCode }).pipe(
          map(
            (result) =>
              new RoomConfigurationLoaded({
                hotelCode: action.payload.hotelCode,
                unitCode: action.payload.unitCode,
                token: result?.Data ?? '',
              })
          )
        )
      )
    );
  });

  setRoomConfigurationEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(RoomConfigurationActionTypes.SET_ROOM_CONFIGURATION),
      switchMap((action: SetRoomConfiguration) =>
        this.api
          .updateToken({
            hotelCode: action.payload.hotelCode,
            room: action.payload.unitCode,
            body: JSON.stringify(action.payload.token),
          })
          .pipe(
            map(
              () =>
                new RoomConfigurationLoaded({
                  hotelCode: action.payload.hotelCode,
                  unitCode: action.payload.unitCode,
                  token: action.payload.token,
                })
            )
          )
      )
    );
  });
}
